import { lazy } from 'react';

const Dashboard = lazy(() => import('./pages/dashboard'));
const FetchSoundRecording = lazy(() =>
  import('./pages/soundrecording/fetch/soundrecordings'),
);
const SoundRecordingDetails = lazy(() =>
  import('./pages/soundrecording/fetch/soundrecordingdetails'),
);
const SearchSoundRecording = lazy(() =>
  import('./pages/soundrecording/post/title/SearchSoundRecording'),
);
const AddSoundRecording = lazy(() =>
  import('./pages/soundrecording/post/title/AddSoundRecording'),
);
const SearchRightsHolder = lazy(() =>
  import('./pages/soundrecording/post/rightsholder/SearchRightsHolder'),
);
const AddNewRightsHolder = lazy(() =>
  import('./pages/soundrecording/post/rightsholder/AddNewRightsHolder'),
);
const AddSearchedRightsHolder = lazy(() =>
  import('./pages/soundrecording/post/rightsholder/AddSearchedRightsHolder'),
);
const SearchRightsHolder2 = lazy(() =>
  import('./pages/soundrecording/fetch/rightsholder/SearchRightsHolder'),
);
const AddNewRightsHolder2 = lazy(() =>
  import('./pages/soundrecording/fetch/rightsholder/AddNewRightsHolder'),
);
const AddSearchedRightsHolder2 = lazy(() =>
  import('./pages/soundrecording/fetch/rightsholder/AddSearchedRightsHolder'),
);
const SoundRecordingsInDispute = lazy(() =>
  import('./pages/soundrecordingsindispute'),
);
const SoundRecordingDisputeUpdate = lazy(() =>
  import('./pages/soundrecordingdisputeupdate'),
);
const FileSoundRecordingDispute = lazy(() =>
  import('./pages/filesoundrecordingdispute'),
);
const SoundRecordingLogs = lazy(() => import('./pages/soundrecordinglogs'));
const Profile = lazy(() => import('./pages/profile'));
const PasswordChange = lazy(() => import('./pages/passwordchange'));
const RightsHolder = lazy(() => import('./pages/rightsholder'));
const Help = lazy(() => import('./pages/help'));
const ErrorPage = lazy(() => import('./pages/errorpage'));
const TestPage = lazy(() => import('./pages/test'));

const routes = [
  {
    path: 'dashboard',
    component: Dashboard,
  },
  {
    path: 'musical-opposition',
    component: SoundRecordingsInDispute,
  },
  {
    path: 'musical-opposition/details/:oppositionId',
    component: SoundRecordingDisputeUpdate,
  },
  {
    path: 'sound-recordings',
    component: FetchSoundRecording,
  },
  {
    path: 'sound-recording/details/:soundrecordingId',
    component: SoundRecordingDetails,
  },
  {
    path: 'sound-recording/dispute/:soundrecordingId',
    component: FileSoundRecordingDispute,
  },
  {
    path: 'sound-recording/search',
    component: SearchSoundRecording,
  },
  {
    path: 'sound-recording-logs',
    component: SoundRecordingLogs,
  },
  {
    path: 'sound-recording/add',
    component: AddSoundRecording,
  },
  {
    path: 'sound-recording/rightsholder/search',
    component: SearchRightsHolder,
  },
  {
    path: 'sound-recording/rightsholder/add',
    component: AddNewRightsHolder,
  },
  {
    path: 'sound-recording/rightsholder/add/search',
    component: AddSearchedRightsHolder,
  },
  {
    path: 'sound-recording/rightsholder/search/:soundrecordingId',
    component: SearchRightsHolder2,
  },
  {
    path: 'sound-recording/rightsholder/add/:soundrecordingId',
    component: AddNewRightsHolder2,
  },
  {
    path: 'sound-recording/rightsholder/add/search/:soundrecordingId',
    component: AddSearchedRightsHolder2,
  },
  {
    path: 'profile',
    component: Profile,
  },
  {
    path: '/password-change',
    component: PasswordChange,
  },
  {
    path: 'rightsholder/details',
    component: RightsHolder,
  },
  {
    path: 'help',
    component: Help,
  },
  {
    path: '/test',
    component: TestPage,
  },
  {
    path: '*',
    component: ErrorPage,
  },
];

export default routes;
